const initialState = {};

// Reducer
export default function LoginState(state = initialState, action = {}) {
  switch (action.type) {
    default:
      return state;
  }
}
